import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { getSelectedBadgeVideoId, selectFocusedVideo } from "slices";

const FocusedVideoShow = () => {
  const focusedVideo = useSelector(selectFocusedVideo);
  const selectedId = useSelector(getSelectedBadgeVideoId);
  var player;

  function youtubeInit() {
    player = new window.YT.Player("player", {
      videoId: focusedVideo.url.split("v=")[1],
      video_id: focusedVideo.url.split("v=")[1],
      events: {
        onStateChange: onPlayerStateChange,
        onError: onPlayerError,
      },
    });

    console.info("player", player);
  }

  function onPlayerStateChange(e) {
    const percentage = (e.target.playerInfo.currentTime / e.target.playerInfo.duration) * 100;

    const eventHash = createEventHash(e.target.videoTitle, e.target.playerInfo.currentTime, percentage);
    window.parent.postMessage(JSON.stringify(eventHash), "*");
  }

  function onPlayerError(e) {
    console.error("err", e);
  }

  function removePlayer() {
    if (window.YT && window.YT.Player && player instanceof window.YT.Player) {
      player.destroy();
    }
  }

  ////////////////////////////////  vimeo

  function vimeoInit(focusedVideo) {
    try {
      let videos = document.getElementsByTagName("iframe");
      for (let i = 0; i < videos.length; ++i) {
        let video = videos[i];
        let player;

        video.onload = function () {
          player = new window.Vimeo.Player(video);

          player.on(["pause", "ended"], function (data) {
            const eventHash = createEventHash(focusedVideo.title, data.seconds, data.percentage * 100);
            window.parent.postMessage(JSON.stringify(eventHash), "*");
          });

          console.info("player", player);
        };
      }
    } catch (err) {
      console.error("err", err);
    }
  }

  function videoInit(focusedVideo) {
    const eventHash = createEventHash(focusedVideo.title);
    window.parent.postMessage(JSON.stringify(eventHash), "*");
  }

  function createEventHash(videoTitle, watchDuration, watchPercentage) {
    return {
      event_name: "h_watch",
      event_params: {
        h_page_type: "hayley",
        h_stream: "hyly",
        h_display_method: "iframe",
        h_video_title: videoTitle,
        h_watch_duration: watchDuration,
        h_watch_percentage: watchPercentage,
        h_video_type: selectedId === "videos" ? "recorded video" : "3d video",
        h_view_type: selectedId === "videos" ? "videos" : "360 tours",
      },
    };
  }

  useEffect(() => {
    const initializeVideo = () => {
      if (!focusedVideo) {
        return;
      }

      const { url } = focusedVideo;

      if (url.includes("youtube.com")) {
        youtubeInit();
      } else if (url.includes("vimeo.com")) {
        vimeoInit(focusedVideo);
      } else {
        videoInit(focusedVideo);
      }
    };
    initializeVideo();

    return () => {
      removePlayer();
    };
  }, [focusedVideo]);

  const content = useMemo(() => {
    if (!focusedVideo) {
      return null;
    }

    // if the url is the full iframe tag
    if (focusedVideo.url.includes("<iframe")) {
      return (
        <Box
          className="hayley-flex hayley-h-full hayley-w-full hayley-items-center hayley-justify-center"
          dangerouslySetInnerHTML={{ __html: focusedVideo.url }}
          sx={{ "& iframe": { width: "100%", height: "100%" } }}
        />
      );
    }

    // if the url is vimeo video url
    if (focusedVideo.url.includes("vimeo.com")) {
      const videoId = focusedVideo.url.split("/").pop();

      return (
        <Box className="hayley-flex hayley-h-[calc(100dvh-410px)] hayley-w-full hayley-items-center hayley-justify-center">
          <iframe
            id="player"
            src={`https://player.vimeo.com/video/${videoId}`}
            title={focusedVideo.title}
            className="hayley-h-full hayley-w-full hayley-border-none"
          />
        </Box>
      );
    }

    // if the url is youtube video url
    if (focusedVideo.url.includes("youtube.com")) {
      const videoId = focusedVideo.url.split("=").pop();

      return (
        <Box className="hayley-flex hayley-h-[calc(100dvh-410px)] hayley-w-full hayley-items-center hayley-justify-center">
          <iframe
            id="player"
            src={`https://www.youtube.com/embed/${videoId}`}
            title={focusedVideo.title}
            className="hayley-h-full hayley-w-full hayley-border-none"
            allowFullScreen
          />
        </Box>
      );
    }

    return (
      <Box className="hayley-flex hayley-h-[calc(100dvh-410px)] hayley-w-full hayley-items-center hayley-justify-center">
        <iframe id="player" src={focusedVideo.url} title={focusedVideo.title} className="hayley-h-full hayley-w-full hayley-border-none" />
      </Box>
    );
  }, [focusedVideo]);

  return (
    <div id="player" className="hayley-hidden hayley-h-[calc(100dvh-410px)] hayley-w-full hayley-flex-1 hayley-bg-gray-100 sm:hayley-flex">
      {content}
    </div>
  );
};

export default FocusedVideoShow;
